export type DevicePreset = 'desktop' | 'tablet' | 'mobile';

export const DEVICE_PRESETS: Record<Exclude<DevicePreset, 'desktop'>, {width: number; height: number; label: string}> = {
    tablet: {width: 820, height: 1180, label: 'Tablet · 820×1180'},
    mobile: {width: 390, height: 844, label: 'Mobile · 390×844'},
};

export const DEVICE_OPTIONS: {value: DevicePreset; label: string}[] = [
    {value: 'desktop', label: 'Desktop'},
    {value: 'tablet', label: 'Tablet'},
    {value: 'mobile', label: 'Mobile'},
];
